(function () {
    'use strict';
    angular.module('Directives').directive('bbaPhoneNumberInput', bbaPhoneNumberInput);
    bbaPhoneNumberInput.$inject = [
        '$document',
        '$window',
        '$timeout'
    ];
    function bbaPhoneNumberInput(
        $document,
        $window,
        $timeout
    ) {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/form-components/bba-phone-number-input.html',
            replace: true,
            require: '^form',
            scope: {
                ngModel: '=',
                location: '=?',
                dataChangeListener: '=?',
                required: '=',
                readonly: '=',
            },
            link: bbaPhoneNumberInputLink,
        }

        function bbaPhoneNumberInputLink($scope, $element) {
            $scope.id = `#phone-number-${Math.random()}`;
            $scope.containerClass = `phone-number-${Math.floor(Math.random() * 100) + 1}`;

            $scope.formatNumber = formatNumber;
            $scope.getTooltip = getTooltip;
            $scope.dataChange = dataChange;

            init();

            function init() {
                locationDataChangesListener();
                initPhoneInputField();
                setNgModelListener();
            }

            function locationDataChangesListener() {
                $scope.$watch('location', () => {
                    updatePhoneCountry();
                }, true);
            }

            function initPhoneInputField() {
                $timeout(function () {
                    const initialCountry = angular.getObjVal($scope.location, 'country.code');
                    const input = $document[0].getElementById($scope.id);

                    $scope.iti = $window.intlTelInput(input, {
                        utilsScript: "/node_modules/intl-tel-input/build/js/utils.js",
                        initialCountry: initialCountry || getCluster().toUpperCase(),
                        customContainer: $scope.containerClass
                    });
                    validateInput();
                }, 500);
            }

            function setNgModelListener() {
                $scope.$watch('ngModel', () => {
                    formatNumber();
                });
            }

            function formatNumber() {
                if ($scope.iti) {
                    $scope.ngModel = $scope.iti.getNumber().trim();
                }
            }

            function updatePhoneCountry() {
                if (!$scope.iti) { return; }
                if (!angular.getObjVal($scope.location, 'country.code')) { return; }
                $scope.iti.setCountry($scope.location.country.code.toLowerCase());
            }

            function validateInput() {
                const modelController = $element.find('input').controller('ngModel');
                $scope.$watch(() => {
                    if ($scope.ngModel && modelController) {

                        const countryData = $scope.iti.getSelectedCountryData();
                        const country = countryData.iso2;

                        if (country === 'au' && !$scope.iti.isValidNumber()) {
                            const phoneRegex = /^(?:\+61|0)?(?:4\d{8}|(?:[2378]\d{8})|(?:[2378]\d{1,2}\s\d{4}\s\d{4})|\(0?[2378]\)\s?\d{4}\s?\d{4})$/;
                            if (phoneRegex.test($scope.ngModel)) {
                                $scope.showFormError = false;
                                modelController.$setValidity('phoneNumberInvalid', true);
                            } else {
                                modelController.$setValidity('phoneNumberInvalid', false);
                                $scope.showFormError = !!(modelController.$invalid && modelController.$touched);
                            }
                        } else {
                            modelController.$setValidity('phoneNumberInvalid', $scope.iti.isValidNumber());
                            modelController.$setTouched();
                            $scope.showFormError = !!(modelController.$invalid && modelController.$touched);
                        }
                        return;
                    }

                    if (!$scope.required) {
                        $scope.showFormError = false;
                        modelController.$setValidity('phoneNumberInvalid', true);
                    }
                });
            }

            function getTooltip() {
                return $scope.showFormError ? 'Phone number invalid' : 'Enter your phone number';
            }

            function dataChange() {
                if ($scope.dataChangeListener) {
                    $scope.dataChangeListener();
                }
            }

            function getCluster() {
                if ($window.location.host.includes('dashboard.ship2anywhere.com.au')) {
                    return 'au';
                }

                if ($window.location.host.includes('dashboard.ship2anywhere.co.uk')) {
                    return 'uk';
                }

                if ($window.location.host.includes('dashboard.ship2anywhere.com')) {
                    return 'us';
                }

                return 'au';
            }
        }
    }
})();



// WEBPACK FOOTER //
// ./js/directives/bbaPhoneNumberInput.js